import classes from "./share.module.scss";
import { UseInput, useInput } from "hooks/useInput";
import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  formatPhoneNumber,
  getDefaultInputValue,
  renderConditionalProp,
} from "utility";
import { Dialog, Input } from "components/common";

interface ShareProps {
  setOpenDialog: (close: boolean) => void;
  data: any;
}

export const Share: React.FC<ShareProps> = ({ setOpenDialog, data }) => {
  const { t } = useTranslation(["common", "payment", "payment_final"]);
  const [formState, setFormState] = useState<any>({ email: "", phone: "" });
  const [showForm, setDialogueState] = useState(true);
  const shareType: UseInput = useInput(getDefaultInputValue(true));
  const checkFormValidity = (): boolean => {
    if (shareType.value && formState.email.ref.current.checkValidity()) {
      return true;
    } else if (
      !shareType.value &&
      formState.phone.ref.current.checkValidity()
    ) {
      return true;
    }
    return false;
  };

  const setFormData = useCallback((key: string, val: any) => {
    if (key === "phone" && val && val.value) {
      val.value = formatPhoneNumber(val.value);
    }
    setFormState((state: any) => {
      return {
        ...state,
        [key]: val,
      };
    });
  }, []);
  const dialogHandler = useCallback(
    (close: boolean) => {
      setOpenDialog(close);
      setDialogueState(true);
      setFormState({ email: "", phone: "" });
    },
    [setOpenDialog]
  );

  const dialogAction = () => {
    if (checkFormValidity()) {
      // SERVICE CALL TO SHARE THE PAYMENT DETAILS
      //dispatch(sharePaymentDetails());
      setDialogueState(false);
    } else {
      shareType.value
        ? formState.email.ref.current.reportValidity()
        : formState.phone.ref.current.reportValidity();
    }
  };
  return (
    <Dialog
      hideIndication={showForm}
      closeIcon
      icon="check_circle"
      dialogClosed={dialogHandler}
      primaryActionLabel={showForm ? t("payment_final:share") : t("common:done")}
      showSecondaryAction={!showForm}
      autoClose={!showForm}
      primaryActionHandler={dialogAction}
    >
      {showForm ? (
        <div>
          <h4 className={classes.header}>
            {t("payment_final:share_method_title")}
          </h4>
          <ft-formfield label="Send via Email" class={classes.share_form_field}>
            <ft-radio
              onClick={shareType.valueChangeHandler}
              {...renderConditionalProp(shareType.value, "checked")}
              value={true}
            ></ft-radio>
          </ft-formfield>
          <Input
            id="email"
            label={t("payment_final:email_label")}
            val={formState.email?.value}
            validationMessage={t("payment_final:email_validation")}
            type="text"
            passState={setFormData}
            extraProp={{
              ...renderConditionalProp(!shareType.value, "disabled"),
              required: shareType.value === true,
            }}
          />
          <ft-formfield label="Send via SMS" class={classes.share_form_field}>
            <ft-radio
              onClick={shareType.valueChangeHandler}
              {...renderConditionalProp(!shareType.value, "checked")}
              value={false}
            ></ft-radio>
          </ft-formfield>
          <Input
            id="phone"
            label={t("payment_final:phone_label")}
            val={formState.phone?.value}
            validationMessage={t("payment_final:phone_validation")}
            type="tel"
            passState={setFormData}
            extraProp={{
              ...renderConditionalProp(shareType.value, "disabled"),
              required: shareType.value === false,
            }}
          />
        </div>
      ) : (
        <div>
          <h3>{t("payment_final:receipt_shared")}</h3>
          {shareType.value ? (
            <p>{formState.email.value}</p>
          ) : (
            <p>{formState.phone.value}</p>
          )}
        </div>
      )}
    </Dialog>
  );
};
